import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, FormGroup, FormFeedback, FormText } from 'reactstrap'
import CreatableSelect from '../../../Wps/CreatableSelect'

const propTypes = {
  values: PropTypes.object,
  dictionaries: PropTypes.object,
  validationErrors: PropTypes.object,
  handleSelectChange: PropTypes.func.isRequired,
}

const Iso960612013 = ({ values, dictionaries, validationErrors, handleSelectChange }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Welding process" id="select-welding-process-certificate-form"
              options={(values.welding_process.length === 2 && values.welding_process.map(item => ({...item, label: `${item.name} - ${item.description}`}))) || dictionaries.welding_processes}
              valueKey="id"
              labelKey="label"
              value={values.welding_process.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('welding_process')} />
            <FormFeedback>{validationErrors.welding_process_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect id="select-product-type-certificate-form"
              label="Product type"
              options={dictionaries.product_types}
              valueKey="id"
              labelKey="label"
              value={values.product_type.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('product_type')}
            />
            <FormFeedback>{validationErrors.product_type_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Type of weld" id="select-type-of-weld-certificate-form"
              options={dictionaries.type_of_welds}
              valueKey="id"
              labelKey="label"
              value={values.type_of_weld.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('type_of_weld')} />
            <FormFeedback>{validationErrors.type_of_weld_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Material group" id="select-material-group-certificate-form"
              options={dictionaries.material_groups}
              valueKey="id"
              labelKey="label"
              value={values.material_group.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('material_group')} />
            <FormFeedback>{validationErrors.material_group}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Filler material group" id="select-filler-material-group-certificate-form"
              options={dictionaries.filler_material_groups}
              valueKey="id"
              labelKey="label"
              value={values.filler_material_group.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('filler_material_group')} />
            <FormFeedback>{validationErrors.filler_material_group_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Filler material" id="select-filler-material-certificate-form"
              options={dictionaries.filler_materials}
              valueKey="id"
              labelKey="label"
              value={values.filler_material.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('filler_material')} />
            <FormText color="muted">
              Choose the <b>Welding process</b> - the possible <b>Filler material</b> depends on this selection!
            </FormText>
            <FormFeedback>{validationErrors.filler_material_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Welding position" id="select-welding-position-certificate-form"
              options={dictionaries.welding_positions}
              valueKey="id"
              labelKey="label"
              value={values.welding_position.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('welding_position')} />
            <FormFeedback>{validationErrors.welding_position_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Weld detail" id="select-weld-detail-certificate-form"
              options={dictionaries.weld_details}
              valueKey="id"
              labelKey="label"
              value={values.weld_detail.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('weld_detail')} />
            <FormText color="muted">
              Choose the <b>Welding process</b> and the <b>Type of weld</b> - the possible <b>Weld details</b> depends on these selections!
            </FormText>
            <FormFeedback>{validationErrors.weld_detail}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Type of current polarity" id="select-type-of-current-polarity-certificate-form"
              options={dictionaries.type_of_current_polarities}
              valueKey="id"
              labelKey="label"
              value={values.type_of_current_polarity.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('type_of_current_polarity')} />
            <FormFeedback>{validationErrors.type_of_current_polarity_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Metal transfer" id="metal-transfer-certificate-form"
              options={dictionaries.metal_transfers}
              valueKey="id"
              labelKey="label"
              value={values.metal_transfer.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('metal_transfer')} />
            <FormFeedback>{validationErrors.metal_transfer_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Type of welding" id="select-type-of-welding-certificate-form"
              options={dictionaries.type_of_weldings}
              valueKey="id"
              labelKey="label"
              value={values.type_of_welding.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('type_of_welding')} />
            <FormFeedback>{validationErrors.type_of_welding_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Revalidation method" id="select-revalidation-method-certificate-form"
              options={dictionaries.revalidation_methods}
              valueKey="id"
              labelKey="label"
              value={values.revalidation_method.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('revalidation_method')} />
            <FormFeedback>{validationErrors.revalidation_method_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  )
}

Iso960612013.propTypes = propTypes

export default Iso960612013



// WEBPACK FOOTER //
// ./src/components/Welders/forms/standards/Iso960612013.js